export default __webpack_public_path__ + "static/media/e-wallet-icon.0a8f8b3e.svg";